import type { CSSProperties } from "react";

/** Majorelle gradient of the dark call-to-action / progress cards. */
export const ENRICHMENT_GRADIENT_STYLE: CSSProperties = {
  background:
    "radial-gradient(120% 200% at 0% 0%, rgba(235, 110, 166, 0.35), transparent 60%), linear-gradient(90deg, #171436 0%, #6647FC 60%, #F26432 130%)",
};
